import React, { useCallback, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Tappable } from '@vectord/components';
import { TypeUtils } from '@vectord/utils';
import cogoToast from 'cogo-toast';

import {
  hasContestLesson,
  isHybridContest,
  SCHEDULE_CLASSES_PAGE_TRACKINGS,
  setScheduleClassesFormErrors,
  showTracker,
  useBulkCreateSbatGroupsMutation,
  validateClassesSchedule,
} from 'features/classCreation';
import analytics from 'utils/analytics';

function ConfirmScheduleButton({ classes }) {
  const dispatch = useDispatch();
  const state = useSelector((state) => state.scheduleClassesForm);
  const { superBatches, library } = state;
  const [
    bulkCreateSbatGroups,
    { isSuccess, data, error, isLoading: isCreating },
  ] = useBulkCreateSbatGroupsMutation();

  const handleClick = useCallback(() => {
    if (isCreating) return;
    let hybridContestNames = [];
    let contestNames = [];
    classes.forEach((cls) => {
      if (isHybridContest(cls.academy_topic.lessons)) {
        hybridContestNames.push(cls.academy_topic.title);
      }
      if (hasContestLesson(cls.academy_topic.lessons)) {
        contestNames.push(cls.academy_topic.title);
      }
    });
    analytics.click({
      click_type: SCHEDULE_CLASSES_PAGE_TRACKINGS.scheduleClasses,
      custom: {
        super_batches_count: superBatches.length,
        super_batch_ids: superBatches.map((o) => o.value),
        library_id: library.value,
        super_batch_names: superBatches.map((o) => o.name),
        hybrid_contest_count: hybridContestNames.length,
        hybrid_contest_name: hybridContestNames,
        contest_count: contestNames.length,
        contest_names: contestNames,
      },
    });
    const errors = validateClassesSchedule(state);
    if (Object.keys(errors).length > 0) {
      dispatch(setScheduleClassesFormErrors(errors));
    } else {
      dispatch(setScheduleClassesFormErrors({}));
      bulkCreateSbatGroups(state);
    }
  }, [
    bulkCreateSbatGroups,
    classes,
    dispatch,
    isCreating,
    library.value,
    state,
    superBatches,
  ]);

  useEffect(() => {
    if (isSuccess) {
      cogoToast.success('Classes schedule request created succesfully!');
      dispatch(showTracker({ classCreationTrackerId: data?.job_id }));
    }
  }, [data?.job_id, dispatch, isSuccess]);

  useEffect(() => {
    if (error) {
      const errors = error?.data?.errors;
      if (TypeUtils.isArray(errors?.base)) {
        dispatch(
          setScheduleClassesFormErrors({ classes_schedule: errors.base })
        );
      } else {
        cogoToast.error(
          error?.data?.message ||
            'Failed to schedule classes. Please try again after sometime!'
        );
      }
    }
  }, [dispatch, error]);

  return (
    <Tappable
      className="btn btn-primary btn-long btn-small"
      disabled={isCreating}
      onClick={handleClick}
    >
      Confirm & Schedule
    </Tappable>
  );
}

export default ConfirmScheduleButton;
